import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript';
import './CodeBlock.css';

SyntaxHighlighter.registerLanguage('javascript', js);

// Custom lightweight theme based on AgriLink colors
const agriLinkTheme = {
  'hljs': {
    display: 'block',
    overflowX: 'auto',
    padding: '1em',
    background: '#F9F9F9',
    color: '#1A1A1A',
  },
  'hljs-comment': { color: '#6B6B6B', fontStyle: 'italic' },
  'hljs-quote': { color: '#6B6B6B', fontStyle: 'italic' },
  'hljs-keyword': { color: '#4A5A3A', fontWeight: 'bold' },
  'hljs-selector-tag': { color: '#4A5A3A', fontWeight: 'bold' },
  'hljs-addition': { color: '#5A7A3A' },
  'hljs-number': { color: '#8A7A4A' },
  'hljs-string': { color: '#5A7A3A' },
  'hljs-meta .hljs-meta-string': { color: '#5A7A3A' },
  'hljs-literal': { color: '#8A7A4A' },
  'hljs-doctag': { color: '#8A7A4A' },
  'hljs-regexp': { color: '#8A4A3A' },
  'hljs-title': { color: '#4A5A3A' },
  'hljs-section': { color: '#4A5A3A', fontWeight: 'bold' },
  'hljs-name': { color: '#4A5A3A', fontWeight: 'bold' },
  'hljs-selector-id': { color: '#4A5A3A', fontWeight: 'bold' },
  'hljs-selector-class': { color: '#4A5A3A' },
  'hljs-attribute': { color: '#7A8A5E' },
  'hljs-attr': { color: '#7A8A5E' },
  'hljs-variable': { color: '#8A4A3A' },
  'hljs-template-variable': { color: '#8A4A3A' },
  'hljs-class .hljs-title': { color: '#4A5A3A' },
  'hljs-type': { color: '#8A7A4A', fontWeight: 'bold' },
};

function CodeBlock({ code, language = 'javascript' }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="code-block">
      <div className="code-block__header">
        <span className="code-block__language">{language}</span>
        <button 
          className="code-block__copy-btn"
          onClick={handleCopy}
          aria-label="Copy code"
        >
          {copied ? <Check size={16} /> : <Copy size={16} />}
          <span>{copied ? 'Copied!' : 'Copy'}</span>
        </button>
      </div>
      <div className="code-block__content">
        <SyntaxHighlighter
          language={language}
          style={agriLinkTheme}
          customStyle={{
            margin: 0,
            padding: '20px',
            background: 'var(--color-gray-50)',
            borderRadius: '0 0 12px 12px',
            fontSize: '13px',
            lineHeight: '1.6',
          }}
        >
          {code}
        </SyntaxHighlighter>
      </div>
    </div>
  );
}

export default CodeBlock;
